import React, { useEffect, useState } from "react";
import {
  Avatar,
  Button,
  CustomTag,
  InfoCardNewAdv,
  StatusTags,
} from "../../../components";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AddVendor from "./AddVendor";
import {
  clearVendorProfile,
  getVendorOneStart,
} from "../../../redux/slices/vendor/vendorSlice";
import { ENDPOINTS } from "../../../redux/apiConfig";
import axiosRequest from "../../../redux/slices/universal/axiosService";
import { getVendorId } from "../../../utils/getClientId";

const VendorDetails = (props) => {
  const [isEditable, setIsEditable] = useState(false);
  const [vendorInfo, setVendorInfo] = useState({});
  const [loading, setLoading] = useState(false);
  console.log("vendorInfo metrics", vendorInfo);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { state } = location;
  const { code: uiid } = state ? state : {};
  const currentVendor = useSelector(
    (state) => state.vendor.currentVendor.vendorDetails,
  );
  const vendorProfileUiid = useSelector(
    (state) => state.vendor.vendorProfileUiid,
  );

  useEffect(() => {
    if (!uiid) return;

    const fetchVendorInfo = async () => {
      try {
        setLoading(true);

        if (vendorProfileUiid) {
          dispatch(clearVendorProfile());
        }
        dispatch(
          getVendorOneStart({
            vendorUiid: uiid,
            retrieve: `uiid vendorType roleContacts dbaName phone businessName email federalId estYear consultantName legalName website generalInfo`,
          }),
        );

        const [allVendorActive, allPlacements] = await Promise.all([
          axiosRequest({
            method: "GET",
            url: ENDPOINTS.VENDORS.GET_BY_UIID,
            params: {
              coll: "Vendor",
              ret: "consultants",
              ref: "PlacementWithEmp",
              incl: "employeeId jobInfo.startDate jobInfo.endDate status",
              fil: JSON.stringify({ uiid: { type: "NONE", value: uiid } }),
            },
          }),
          axiosRequest({
            method: "GET",
            url: ENDPOINTS.PLACEMENTS.GET_ALL,
            params: {
              coll: "Placement",
              ret: "employeeId",
              fil: JSON.stringify({
                "vendor.id": { type: "NONE", value: uiid },
              }),
            },
          }),
        ]);

        let activePlacements = allVendorActive?.data?.data?.consultants;
        activePlacements = Array.from(
          new Map(
            activePlacements
              ?.filter((item) => {
                const endDate = item?.jobInfo?.endDate
                  ? new Date(item.jobInfo.endDate)
                  : null;
                return (
                  item?.jobInfo?.status !== 2 &&
                  (!endDate || endDate >= new Date())
                );
              })
              .map((item) => [item.employeeId.uiid, item]),
          ).values(),
        );

        let allConsultants = allPlacements?.data?.data || [];
        setVendorInfo({
          consultantsWorked:
            new Set(allConsultants?.map((item) => item?.employeeId)).size || 0,
          activeConsultants: activePlacements?.length || 0,
        });
      } catch (error) {
        console.error("error", error);
      } finally {
        setLoading(false);
      }
    };

    fetchVendorInfo();
  }, [uiid]);
  const handleToggleEdit = () => {
    setIsEditable(!isEditable);
  };
  return (
    <div className="mt-3 flex flex-col gap-2 ">
      <div className="flex flex-col-reverse xl:flex-row gap-3">
        <div className="flex items-center gap-2 flex-1">
          <div>
            <Avatar size="xxl" alt={"Zodiac Solutions Inc"} />
          </div>
          <div className="flex flex-col justify-between gap-1 flex-1">
            <div className="flex gap-2 items-center">
              {console.log("currentVendor", currentVendor)}
              <h6 className="subtitle-reg">{`${currentVendor?.businessName} - ${
                currentVendor?.uiid ? getVendorId(currentVendor?.uiid) : ""
              }`}</h6>
              <StatusTags
                tag={
                  currentVendor?.generalInfo?.recordStatus === 1
                    ? "Active"
                    : "Inactive"
                }
                icon
              />
            </div>
            <div className="flex gap-2 items-center">
              <span className="body-two text-neutrals">
                {[
                  currentVendor?.generalInfo?.invoiceLocation?.city,
                  currentVendor?.generalInfo?.invoiceLocation?.state,
                  currentVendor?.generalInfo?.invoiceLocation?.country,
                ]
                  .filter(Boolean)
                  .join(", ")}
              </span>
            </div>
          </div>
          <div className="flex gap-3 flex-1">
            <div>
              <InfoCardNewAdv
                layout="option6"
                value={vendorInfo?.consultantsWorked || "0"}
                title={"Consultant Worked"}
                icon={"directions_run"}
                iconConfig={{ className: "text-[24px]! text-black!" }}
                valueConfig={{ className: "text-black! ml-[16px]!" }}
                titleConfig={{ className: "text-black! font-semibold!" }}
                bgConfig={{ className: "bg-info-50!" }}
                isLoading={loading}
              />
            </div>
            <div>
              <InfoCardNewAdv
                layout="option6"
                value={vendorInfo?.activeConsultants || "0"}
                title={"Active Consultants"}
                icon={"hail"}
                iconConfig={{ className: "text-[24px]! text-success!" }}
                valueConfig={{ className: "text-success! ml-[16px]!" }}
                titleConfig={{ className: "text-success!" }}
                bgConfig={{ className: "bg-success-50!" }}
                isLoading={loading}
              />
            </div>
          </div>
        </div>

        <div className="flex gap-3 justify-end">
          <div>
            <Button
              type="button"
              title={"Back"}
              icon={"arrow_left_alt"}
              size={"sm"}
              onClick={() => navigate("/vendor")}
            />
          </div>
          <div>
            {!isEditable && (
              <Button
                type="button"
                title={"Edit"}
                size={"sm"}
                icon={"edit_square"}
                onClick={() => handleToggleEdit()}
              />
            )}
          </div>
        </div>
      </div>
      <div className="mt-2">
        <AddVendor
          isEditable={isEditable}
          setIsEditable={setIsEditable}
          vendorId={uiid}
        />
      </div>
    </div>
  );
};

export default VendorDetails;
